import { render, staticRenderFns } from "./serve-info-chart.vue?vue&type=template&id=123eb5a5&"
import script from "./serve-info-chart.vue?vue&type=script&lang=js&"
export * from "./serve-info-chart.vue?vue&type=script&lang=js&"
import style0 from "./serve-info-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports